import { BtmReturnRequest, IBaseBtmReturnRequestDetailsDto } from "../../model/btm-return-request";
import { httpPatch } from "../../../../../common/network/fetch";

export const SaveReturnRequestHandler = async (request: BtmReturnRequest) => {
    const saveReturnRequestResponse = await httpPatch<{ returnRequest: IBaseBtmReturnRequestDetailsDto }>({
        url: `/return-request/${request.id.toString()}`,
        data: {
            carrierName: request.carrier,
            isBulkyCarrier: request.isBulkyCarrier,
            pickupDate: request.pickupDate?.toISOString(),
            serviceWindow: request.serviceWindow?.toString(),
            appointmentRequested: request.isAppointmentRequested,
            shippingInformation: request.shippingInfo
                .filter(shipping => (shipping.tracking ?? "") !== "")
                .map(shipping => ({
                    tracking: shipping.tracking,
                    labelFile: shipping.file,
                })),
        },
    }, false);

    return new BtmReturnRequest({
        ...request.toDto(),
        returnRequest: saveReturnRequestResponse.returnRequest,
    });
};
